import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import moviesReducer from "./movieSlice"
import gptReduder from "./gptSlice";
import configReducer from "./configSlice";

const appStore = configureStore(
    {
        reducer:{
            user: userReducer,
            movies: moviesReducer,
            gpt: gptReduder,
            config: configReducer,
        },
    });
export default appStore;
